angular.module('TetherApp').factory('contactService', [
    '$http',
    function ($http) {
        let sendContact = function (body) {
            return $http.post(
                '/api/v1/user/contact',
                {
                    body: body
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let sendTechnical = function (body, currentUrl) {
            return $http.post('/api/v1/user/support', {
                body: body,
                current_url: currentUrl
            }, { cache: false, headers: { 'Cache-Control' : 'no-cache' } })
                .then(function (response) {
                    return response.data;
                });
        };

        return {
            sendContact: sendContact,
            sendTechnical: sendTechnical
        }

    }
]);
